import React, { useState } from "react";
import { Card, CardBody, Row, Col, Button } from "reactstrap";
import StatsModal from "../Common/StatsModal";
import api from "../../api";
import { toast } from "react-toastify";
import jwt_decode from "jwt-decode";
import PvPChallengeModal from "../Modals/PvPChallengeModal";

const PlayerProfileMainTab = ({
  profile,
  roster,
  level,
  rankings,
  getLevel,
  catcherLevel,
}) => {
  const [challengeSending, setChallengeSending] = useState(false);
  const [showChallengeModal, setShowChallengeModal] = useState(false);

  // Get current user from JWT
  const getCurrentUser = () => {
    const token = localStorage.getItem("jwtToken");
    if (token) {
      try {
        const decoded = jwt_decode(token);
        return decoded.sub || decoded.username;
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
    return null;
  };

  const currentUser = getCurrentUser();
  const isOwnProfile = currentUser === profile?.username;

  // Handle battle challenge
  const handleChallenge = async () => {
    if (!profile?.username) return;
    
    setChallengeSending(true);
    try {
      await api.post("/v1/pvp/challenge", {
        opponent_username: profile.username
      }, { withCredentials: true });
      
      toast.success(`Battle challenge sent to ${profile.username}!`, {
        position: "top-center",
        autoClose: 3000
      });
    } catch (error) {
      const errorMsg = error.response?.data?.detail || "Failed to send challenge";
      toast.error(errorMsg, {
        position: "top-center",
        autoClose: 3000
      });
    } finally {
      setChallengeSending(false);
    }
  };
  // Helper for ordinal rank (local to this component)
  const getOrdinalRank = (rank) => {
    const j = rank % 10,
      k = rank % 100;
    if (j === 1 && k !== 11) return `${rank}st`;
    if (j === 2 && k !== 12) return `${rank}nd`;
    if (j === 3 && k !== 13) return `${rank}rd`;
    return `${rank}th`;
  };


    const [statsModal, setStatsModal] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [modalData, setModalData] = useState(null);
    const toggleStatsModal = () => setStatsModal(on => !on);


    
   const openStats = async (mon) => {
    setModalLoading(true);
    setStatsModal(true);
    try {
      const { data } = await api.get(`/v1/pokemon/${mon.id}`, { withCredentials: true });
      setModalData(data);
    } catch (err) {
      setModalData({ error: err.response?.data?.detail || "Failed to load" });
    } finally {
      setModalLoading(false);
    }
  };

  

  // getAwardImage now returns the proper image for each rank.
  const getAwardImage = (rank) => {
    if (rank === 1) {
      return (
        <img
          src={`/items/1st.png`}
          alt="1st Award"
          style={{
            width: "24px",
            verticalAlign: "middle",
            marginLeft: "0.5rem",
          }}
        />
      );
    } else if (rank === 2) {
      return (
        <img
          src={`/items/2nd.png`}
          alt="2nd Award"
          style={{
            width: "24px",
            verticalAlign: "middle",
            marginLeft: "0.5rem",
          }}
        />
      );
    } else if (rank === 3) {
      return (
        <img
          src={`/items/3rd.png`}
          alt="3rd Award"
          style={{
            width: "24px",
            verticalAlign: "middle",
            marginLeft: "0.5rem",
          }}
        />
      );
    }
    return null;
  };

  function getCatcherLevel(exp) {
    const lvl = Math.floor(Math.pow(exp, 1 / 2.5));
    return Math.pow(lvl + 1, 2.5) <= exp ? lvl + 1 : lvl;
  }

  function getMiningLevel(exp) {
    const lvl = Math.floor(Math.pow(exp, 1 / 2.5));
    return Math.pow(lvl + 1, 2.5) <= exp ? lvl + 1 : lvl;
  }

  // Debug profile data
  console.log("Profile data:", profile);
  console.log("Last active:", profile?.last_active);
  console.log("Is online:", profile?.is_online);

  // Format the last active time in a user-friendly way
  const formatLastActiveTime = (timestamp) => {
    if (!timestamp) return "";
    
    const now = Math.floor(Date.now() / 1000);
    const diff = now - timestamp;
    
    if (diff < 60) return "just now";
    if (diff < 3600) return `${Math.floor(diff / 60)} minutes ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)} hours ago`;
    if (diff < 604800) return `${Math.floor(diff / 86400)} days ago`;
    
    // For longer periods, show the actual date
    const date = new Date(timestamp * 1000);
    return date.toLocaleDateString();
  };

  return (
    <div>
      <Card
        style={{
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
          border: "none",
          overflow: "hidden",
          transition: "transform 0.2s ease, box-shadow 0.2s ease",
          backgroundColor: "#1d222e",
          marginBottom: "1rem"
        }}
      >
        <CardBody className=" text-white rounded p-4" style={{ backgroundColor: "#242836" }}>
          <Row className="align-items-center">
            <Col md="2" className="text-center">
              <img
                src={`/avatars/${profile?.avatar}.png`}
                alt="Avatar"
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  marginBottom: "1rem",
                }}
              />
            </Col>

            <Col md="10">
              <div className="mb-3">
                {(() => {
                  // Define staff members and their roles
                  const staffRoles = {
                    'Brokeboy': 'Developer',
                    'ZigCiguzo': 'Developer', 
                    'JoeD2Cold': 'Admin',
                    'EmoNovember': 'Moderator'
                  };
                  
                  const userRole = staffRoles[profile.username];
                  
                  return (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap', justifyContent: 'space-between' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                        <h3 className="text-white mb-0">{profile.username}</h3>
                        <span style={{
                          backgroundColor: userRole ? (
                            userRole === 'Developer' ? '#E91E63' : 
                            userRole === 'Admin' ? '#FF5722' : '#9C27B0'
                          ) : '#6c757d',
                          color: '#fff',
                          padding: '4px 12px',
                          borderRadius: '16px',
                          fontSize: '0.75rem',
                          fontWeight: '600',
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.3)'
                        }}>
                          {userRole || 'Trainer'}
                        </span>
                        {/* Online Status Indicator */}
                        {profile.is_online && (
                          <span style={{
                            backgroundColor: '#22c55e',
                            color: '#fff',
                            padding: '4px 12px',
                            borderRadius: '16px',
                            fontSize: '0.75rem',
                            fontWeight: '600',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            boxShadow: '0 2px 4px rgba(34, 197, 94, 0.3)'
                          }}>
                            <span style={{
                              width: '8px',
                              height: '8px',
                              borderRadius: '50%',
                              backgroundColor: '#fff',
                              animation: 'pulse 2s infinite'
                            }}></span>
                            ONLINE
                          </span>
                        )}
                      </div>
                      
                      {/* Battle Challenge Button - Only show if online and not own profile */}
                      {!isOwnProfile && profile.is_online && (
                        <Button
                          color="danger"
                          size="sm"
                          onClick={() => setShowChallengeModal(true)}
                          disabled={challengeSending}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            fontWeight: '600',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px',
                            boxShadow: '0 2px 8px rgba(239, 68, 68, 0.3)',
                            border: 'none',
                            transition: 'all 0.2s ease'
                          }}
                        >
                          {challengeSending ? 'Sending...' : 'Challenge to Battle'}
                        </Button>
                      )}
                    </div>
                  );
                })()}
              </div>
              <div className="mb-3">
                {/* Currency & Pokédex - Compact Layout */}
                <div
                  style={{
                    background: "linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.02) 100%)",
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    borderRadius: "8px",
                    padding: "10px 14px",
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    gap: "16px",
                    marginBottom: "12px"
                  }}
                >
                  {/* Coins */}
                  <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <img src="/items/coin.png" alt="coin" style={{ width: "20px", height: "20px" }} />
                    <strong style={{ color: "#eab308" }}>{profile.coins.toLocaleString()}</strong>
                  </div>

                  {/* Money */}
                  <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <img src="/items/money.png" alt="money" style={{ width: "20px", height: "20px" }} />
                    <strong style={{ color: "#22c55e" }}>{profile.money.toLocaleString()}</strong>
                  </div>

                  {/* Pokédex */}
                  <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <img src="/items/pokedex.png" alt="pokedex" style={{ width: "20px", height: "20px" }} />
                    <span style={{ color: "#3b82f6", fontWeight: "600" }}>{profile.pokedex_count.toLocaleString()} Species</span>
                  </div>
                </div>

                {/* Levels in a professional grid */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
                    gap: "10px"
                  }}
                >
                  {/* Trainer Level */}
                  <div style={{
                    background: "linear-gradient(135deg, rgba(239, 68, 68, 0.15) 0%, rgba(220, 38, 38, 0.05) 100%)",
                    border: "1px solid rgba(239, 68, 68, 0.3)",
                    borderRadius: "8px",
                    padding: "8px 12px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    transition: "all 0.2s ease",
                    cursor: "default"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(239, 68, 68, 0.2)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                  >
                    <img
                      src="/items/battleseek.png"
                      alt="trainer level"
                      style={{ width: "24px", height: "24px" }}
                    />
                    <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                      <span style={{ fontSize: "0.7rem", color: "rgba(255, 255, 255, 0.6)", textTransform: "uppercase", fontWeight: "600" }}>Trainer</span>
                      <span style={{ fontSize: "0.95rem", fontWeight: "700", color: "#ef4444" }}>Lv. {getLevel(profile.exp).toLocaleString()}</span>
                    </div>
                  </div>

                  {/* Catcher Level */}
                  <div style={{
                    background: "linear-gradient(135deg, rgba(34, 197, 94, 0.15) 0%, rgba(22, 163, 74, 0.05) 100%)",
                    border: "1px solid rgba(34, 197, 94, 0.3)",
                    borderRadius: "8px",
                    padding: "8px 12px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    transition: "all 0.2s ease",
                    cursor: "default"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(34, 197, 94, 0.2)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                  >
                    <img
                      src="/items/pokeball.png"
                      alt="catcher level"
                      style={{ width: "24px", height: "24px" }}
                    />
                    <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                      <span style={{ fontSize: "0.7rem", color: "rgba(255, 255, 255, 0.6)", textTransform: "uppercase", fontWeight: "600" }}>Catcher</span>
                      <span style={{ fontSize: "0.95rem", fontWeight: "700", color: "#22c55e" }}>Lv. {getCatcherLevel(profile.catcher_exp).toLocaleString()}</span>
                    </div>
                  </div>

                  {/* Mining Level */}
                  <div style={{
                    background: "linear-gradient(135deg, rgba(161, 98, 7, 0.15) 0%, rgba(120, 53, 15, 0.05) 100%)",
                    border: "1px solid rgba(161, 98, 7, 0.3)",
                    borderRadius: "8px",
                    padding: "8px 12px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    transition: "all 0.2s ease",
                    cursor: "default"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(161, 98, 7, 0.2)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                  >
                    <img
                      src="/items/NormalPickaxe.png"
                      alt="mining level"
                      style={{ width: "24px", height: "24px" }}
                    />
                    <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                      <span style={{ fontSize: "0.7rem", color: "rgba(255, 255, 255, 0.6)", textTransform: "uppercase", fontWeight: "600" }}>Mining</span>
                      <span style={{ fontSize: "0.95rem", fontWeight: "700", color: "#d97706" }}>Lv. {getMiningLevel(profile.miningexp).toLocaleString()}</span>
                    </div>
                  </div>

                  {/* Fishing Level */}
                  <div style={{
                    background: "linear-gradient(135deg, rgba(59, 130, 246, 0.15) 0%, rgba(37, 99, 235, 0.05) 100%)",
                    border: "1px solid rgba(59, 130, 246, 0.3)",
                    borderRadius: "8px",
                    padding: "8px 12px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    transition: "all 0.2s ease",
                    cursor: "default"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(59, 130, 246, 0.2)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                  >
                    <img
                      src="/items/superrod.png"
                      alt="fishing level"
                      style={{ width: "24px", height: "24px" }}
                    />
                    <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                      <span style={{ fontSize: "0.7rem", color: "rgba(255, 255, 255, 0.6)", textTransform: "uppercase", fontWeight: "600" }}>Fishing</span>
                      <span style={{ fontSize: "0.95rem", fontWeight: "700", color: "#3b82f6" }}>Lv. {getMiningLevel(profile.fishingexp || 0).toLocaleString()}</span>
                    </div>
                  </div>

                  {/* Farming Level */}
                  <div style={{
                    background: "linear-gradient(135deg, rgba(251, 146, 60, 0.15) 0%, rgba(249, 115, 22, 0.05) 100%)",
                    border: "1px solid rgba(251, 146, 60, 0.3)",
                    borderRadius: "8px",
                    padding: "8px 12px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    transition: "all 0.2s ease",
                    cursor: "default"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(251, 146, 60, 0.2)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                  >
                    <img
                      src="/items/razzberry.png"
                      alt="farming level"
                      style={{ width: "24px", height: "24px" }}
                    />
                    <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                      <span style={{ fontSize: "0.7rem", color: "rgba(255, 255, 255, 0.6)", textTransform: "uppercase", fontWeight: "600" }}>Farming</span>
                      <span style={{ fontSize: "0.95rem", fontWeight: "700", color: "#fb923c" }}>Lv. {getMiningLevel(profile.farmingexp || 0).toLocaleString()}</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Last Active Status */}
              {profile.last_active && (
                <div className="mt-3 mb-2">
                  <div style={{ 
                    display: 'inline-flex', 
                    alignItems: 'center', 
                    gap: '8px',
                    backgroundColor: profile.is_online ? 'rgba(76, 175, 80, 0.1)' : 'rgba(244, 67, 54, 0.1)',
                    padding: '6px 12px',
                    borderRadius: '16px',
                    border: `1px solid ${profile.is_online ? 'rgba(76, 175, 80, 0.3)' : 'rgba(244, 67, 54, 0.3)'}`,
                  }}>
                    <div style={{
                      width: '10px',
                      height: '10px',
                      borderRadius: '50%',
                      backgroundColor: profile.is_online ? '#4CAF50' : '#F44336',
                      boxShadow: profile.is_online ? '0 0 8px #4CAF50' : 'none'
                    }}></div>
                    <span style={{
                      color: profile.is_online ? '#4CAF50' : '#F44336',
                      fontWeight: '600'
                    }}>
                      {profile.is_online ? 'Online' : 'Offline'}
                    </span>
                    {!profile.is_online && profile.last_active && (
                      <span style={{ 
                        color: '#FFFFFF', 
                        fontSize: '0.9em', 
                        marginLeft: '4px',
                        textShadow: '0px 0px 1px rgba(0, 0, 0, 0.7)',
                        fontWeight: '500'
                      }}>
                        - {formatLastActiveTime(profile.last_active)}
                      </span>
                    )}
                  </div>
                </div>
              )}
              
              {rankings ? (
               <div className="mt-3">
                 <h5 className="mb-2">Leaderboard Rankings</h5>
                 <Row>
                   <Col md="4">
                     Trainer:{" "}
                     {rankings.trainer.rank <= 3
                       ? getAwardImage(rankings.trainer.rank)
                       : getOrdinalRank(rankings.trainer.rank)}
                   </Col>
                   <Col md="4">
                     Catcher:{" "}
                     {rankings.catcher.rank <= 3
                       ? getAwardImage(rankings.catcher.rank)
                       : getOrdinalRank(rankings.catcher.rank)}
                   </Col>
                   <Col md="4">
                     Mining:{" "}
                     {rankings.mining.rank <= 3
                       ? getAwardImage(rankings.mining.rank)
                       : getOrdinalRank(rankings.mining.rank)}
                   </Col>
                 </Row>
               </div>
             ):(
               <div style={{ color: "#aaa" }}>
                                             <img
                                               src="/loading.gif"
                                               alt="Loading..."
                                               width="32"
                                             />{" "}
                                             Loading rankings...
                                           </div>
             )
             
             }
            </Col>
          </Row>
        </CardBody>
      </Card>
      <h5 style={{
        color: "#fff",
        marginBottom: "1rem",
        paddingLeft: "0.5rem",
        borderLeft: "3px solid rgba(16, 185, 129, 0.8)"
      }}>Party</h5>
      <Row>
        {roster.length > 0 ? (
          roster.map((poke) => (
            <Col key={poke.id} md="3" sm="6" className="mb-3">
              <Card
                style={{
                  borderRadius: "12px",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                  border: "none",
                  overflow: "hidden",
                  transition: "transform 0.2s ease, box-shadow 0.2s ease",
                  cursor: "pointer",
                  backgroundColor: "#1d222e"
                }}
                onClick={() => openStats(poke)}
                className="hover-effect"
              >
                <CardBody className="text-center" style={{
                  backgroundColor: "#242836",
                  padding: "1.25rem"
                }}>
                  <img
                    src={`/sprites/${poke.name}.png`}
                    alt={poke.name}
                    style={{ width: "120px" }}
                  />
                  <h6 style={{ 
                    marginTop: "0.75rem",
                    color: "#ffffff",
                    fontWeight: "600"
                  }}>
                    {poke.nickname || poke.name}
                  </h6>
                  <div style={{ 
                    fontSize: "0.9rem",
                    color: "rgba(255, 255, 255, 0.8)",
                    marginTop: "0.5rem"
                  }}>
                    <div style={{
                      backgroundColor: "rgba(16, 185, 129, 0.2)",
                      color: "#10b981",
                      borderRadius: "4px",
                      padding: "0.25rem 0.5rem",
                      display: "inline-block",
                      fontWeight: "500"
                    }}>
                      Level: {getLevel(poke.totalexp).toLocaleString()}
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))
        ) : (
          <div style={{ 
            color: "rgba(255, 255, 255, 0.7)",
            backgroundColor: "rgba(255, 255, 255, 0.05)",
            borderRadius: "8px",
            padding: "1.5rem",
            textAlign: "center",
            border: "1px solid rgba(255, 255, 255, 0.1)"
          }}>
            <i className="ri-ghost-line" style={{ fontSize: "2rem", marginBottom: "0.5rem" }}></i>
            <p>No Pokémon in this roster.</p>
          </div>
        )}
      </Row>
      <StatsModal
              isOpen={statsModal}
              toggle={toggleStatsModal}
              loading={modalLoading}
              data={modalData}
            />
            
      {/* PvP Challenge Modal */}
      {showChallengeModal && (
        <PvPChallengeModal
          onClose={() => setShowChallengeModal(false)}
          targetUsername={profile?.username}
          onChallengeSuccess={() => {
            toast.success(`Battle challenge sent to ${profile?.username}!`, {
              position: "top-center",
              autoClose: 3000
            });
          }}
        />
      )}
    </div>
  );
};

export default PlayerProfileMainTab;
